module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_8_after.jpg
// module id = 1207
// module chunks = 0